var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.47,
    y1: -0.011,
    x2: 0.472,
    y2: 1.046,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbaba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#980d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#ba1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#be1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#dc4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#ff7b7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f97b7b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16078",
    "data-name": "Group 16078",
    transform: "translate(1.32 -0.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9969",
    "data-name": "Group 9969",
    transform: "translate(-1.32 0.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 75.5,
    cy: 75.5,
    r: 75.5,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_67_-_Outline",
    "data-name": "Ellipse 67 - Outline",
    d: "M75.5,6.051A69.449,69.449,0,0,0,26.392,124.608a69.449,69.449,0,1,0,98.216-98.216A69,69,0,0,0,75.5,6.051M75.5,0A75.5,75.5,0,1,1,0,75.5,75.5,75.5,0,0,1,75.5,0Z",
    transform: "translate(0 0)",
    fill: "#d63434"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12474",
    "data-name": "Group 12474",
    transform: "translate(60.087 39.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19326",
    "data-name": "Path 19326",
    d: "M6436.363,4498.354a2.71,2.71,0,0,1-3.008-2.414c-.762-7.971-1.574-16.016-2.273-23.1q-.891-8.912-1.781-17.809l-1.074-10.594c-.008-.164-.016-.326-.023-.518l-.023-.287a1.565,1.565,0,0,1,.559-1.252,2.247,2.247,0,0,1,1.473-.529h21.145a2.22,2.22,0,0,1,1.5.543,1.534,1.534,0,0,1,.535,1.289l-.184,1.994c-.141,1.35-.266,2.682-.4,4.012q-.5,5.054-1,10.109c-.41,3.965-.8,7.922-1.211,11.883-.3,3.08-.621,6.164-.918,9.242-.477,4.7-.934,9.395-1.406,14.086-.258,2.637-1.164,3.316-4.309,3.318h-.48c-.648,0-1.293,0-1.941,0H6439.6c-1.234,0-2.223,0-3.133.029Z",
    transform: "translate(-6428.178 -4441.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19327",
    "data-name": "Path 19327",
    d: "M6447.406,4650.643a9.1,9.1,0,1,1-9.105,9.105A9.134,9.134,0,0,1,6447.406,4650.643Z",
    transform: "translate(-6434.797 -4587.125)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconAlert);
export default __webpack_public_path__ + "static/media/general-icon-alert.9676c57ae8b0306d75ede7c2dd4ca71e.svg";
export { ForwardRef as ReactComponent };